import { render } from "./GoogleScopeChecker.vue?vue&type=template&id=306046da&ts=true"
import script from "./GoogleScopeChecker.vue?vue&type=script&lang=ts"
export * from "./GoogleScopeChecker.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__